import isNumber from 'lodash-es/isNumber';

export default function isNumberLike(val: any) {
  // fail
  if (val === null || val === void 0 || val === false) {
    return false;
  }
  if (typeof val === 'function' || val instanceof Array) {
    return false;
  }
  const length = val.length;
  if (!length) {
    return isNumber(val);
  }
  let i = 0;
  // charAt is faster in v8
  if (val.charAt(0) === '-') {
    if (length === 1) {
      // fail do it
      return false;
    }
    i = 1;
  }
  let foundE = false;
  let foundPeriod = false;
  for (; i < length; i++) {
    const c = val.charAt(i);
    // bit range is outside number range
    if (c <= '/' || c >= ':') {
      if (c === 'e') {
        if (foundE) {
          return false;
        }
        foundE = true;
      } else if (c === '.') {
        if (foundPeriod) {
          return false;
        }
        foundPeriod = true;
      } else {
        return false;
      }
    }
  }
  return true;
}
